$(document).ready(function(){

    if( $('.bannerclicktoboat').length > 0 ) {
        $('.instagram').addClass('instagram-bleu-fonce');
    }

});